import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';

class OilOrderDetails extends Component {
  render() {
    const timeMask = 'm/d/yy h:MM:ss TT Z';
    const oilOrder = this.props.order.oilOrder;
    return (
      <span key={this.props.order.id} className="order-item">
        {/* <div className="invoice-number"> */}
        <div className="report-col-temp">
          {this.props.order.invoiceNumber ? this.props.order.invoiceNumber : 'N/A'}
        </div>
        {/* <div className="expected-fulfill-date"> */}
        <div className="report-col-temp">
          {this.props.order.closedAt ? dateFormat(this.props.order.closedAt, timeMask) : 'N/A' }
        </div>
        {/* <div className="fulfilled-at"> */}
        <div className="report-col-temp">
          {dateFormat(this.props.order.fulfilledAt, timeMask) }
        </div>
        {/* <div className="customer-name"> */}
        <div className="report-col-temp">
          {this.props.order.customerName ? this.props.order.customerName : 'N/A' }
        </div>
        {/* <div className="tail-number"> */}
        <div className="report-col-temp">
          {this.props.order.tailNumber ? this.props.order.tailNumber : 'N/A'}
        </div>
        {/* <div className="tail-number"> */}
        <div className="report-col-temp">
          {oilOrder.oilType.name ? oilOrder.oilType.name : 'N/A'}
        </div>
        {/* <div className="tail-number"> */}
        <div className="report-col-temp">
          {oilOrder.quantity ? oilOrder.quantity : 'N/A'}
        </div>
        <div className="clear" />
      </span>
    );
  }
}

OilOrderDetails.propTypes = {
  order: PropTypes.shape({
    orderNumber: PropTypes.number.isRequired,
    invoiceNumber: PropTypes.string,
    closedAt: PropTypes.string,
    fulfilledAt: PropTypes.string.isRequired,
    customerName: PropTypes.string.isRequired,
    tailNumber: PropTypes.string,
    oilOrder: PropTypes.shape({}).isRequired,
  }).isRequired,
};

export default OilOrderDetails;



// WEBPACK FOOTER //
// ./src/Containers/Reports/MonthlyOil/OilOrderDetails.js